import React from 'react';
import { PostResponseSchema } from '@api/client';
import PostCardEventPostType from './PostCardEventPostType';

interface Props {
  post: PostResponseSchema;
  onVideoClick?: (post: PostResponseSchema) => void;
  onImageClick?: (post: PostResponseSchema) => void;
  wrapperStyle?: React.CSSProperties;
}

export default function PostCardEvent(props: Props): React.ReactElement {
  return <PostCardEventPostType {...props} />;
}
